module.exports = __webpack_public_path__ + "media/events/event2-d10f5360.jpg";